import { t } from 'i18next';
import { SeverityColors, palette } from '../../config/theme/theme';

export enum Severity {
  HIGH = 'high',
  MED = 'med',
  LOW = 'low',
  PASSED = 'passed',
  FILTERED = 'filtered',
  DISABLED = 'disabled',
  NA = 'na',
  NO_WARNING = 'noWarning',
}

/**
 * Helper method for the label to display in our UI.
 */
export const getLabel = (type: Severity): string => {
  switch (type) {
    case Severity.HIGH:
      return t('severity.label.high');
    case Severity.MED:
      return t('severity.label.medium');
    case Severity.LOW:
      return t('severity.label.low');
    case Severity.PASSED:
      return t('severity.label.passed');
    case Severity.DISABLED:
      return t('severity.label.disabled');
    case Severity.FILTERED:
      return t('severity.label.filtered');
    case Severity.NA:
      return t('severity.label.na');
    case Severity.NO_WARNING:
      return t('severity.label.noWarning');
    default:
      return type;
  }
};

/**
 * Helper method for the tag label to display in our UI.
 * It has to be shorter version of the original label (if it can be).
 */
export const getTagLabel = (type: Severity): string => {
  switch (type) {
    case Severity.HIGH:
      return t('severity.tag.high');
    case Severity.MED:
      return t('severity.tag.medium');
    case Severity.LOW:
      return t('severity.tag.low');
    case Severity.PASSED:
      return t('severity.tag.passed');
    case Severity.DISABLED:
      return t('severity.tag.disabled');
    case Severity.FILTERED:
      return t('severity.tag.filtered');
    case Severity.NA:
      return t('severity.tag.na');
    case Severity.NO_WARNING:
      return t('severity.tag.noWarning');
    default:
      return type;
  }
};

export const SEVERITY_COLORS: Record<Severity, SeverityColors> = {
  [Severity.HIGH]: palette.severities.high,
  [Severity.MED]: palette.severities.med,
  [Severity.LOW]: palette.severities.low,
  [Severity.PASSED]: palette.severities.passed,
  [Severity.FILTERED]: palette.severities.filtered,
  [Severity.DISABLED]: palette.severities.disabled,
  [Severity.NA]: palette.severities.na,
  [Severity.NO_WARNING]: palette.severities.noWarning,
};

export const getAll = (): Severity[] => {
  return [Severity.HIGH, Severity.MED, Severity.LOW, Severity.NO_WARNING];
};
